import React from 'react';
import { SectionContainer } from '../components/SectionContainer';
import SectionTitle from '../components/SectionTitle';
import { SectionBody } from '../components/SectionBody';
import { SectionLine } from '../components/SectionLine';

import { Half } from '../components/Half';
import SpecialLabel from '../components/SpecialLabel';
import SpecialLabelText from '../components/SpecialLabelText';
import { CheckboxsContainer } from '../components/CheckboxsContainer';
import Checkbox from '../components/Checkbox';
import { FormikPremiumInput } from 'modules/emergencies/components/ui/inputs/customInput';
import { CustomSpace } from '../components/CustomSpace';
import ADDITIONAL_SERVICES from '../../../constants/additionalServices';

export const ComplementaryInfoSection = ({ ticketFormBodyData }) => {
  const { isReadOnly, showErrors } = ticketFormBodyData;

  return (
    <SectionContainer>
      <SectionTitle>Complementary info</SectionTitle>

      <SectionBody>
        {/* customer reference and deadline */}
        <SectionLine>
          <CustomSpace />
        </SectionLine>
        <SectionLine>
          <Half>
            <SectionLine>
              <SpecialLabel>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16 6V4H12V0H10V4H6V0H4V4H0V6H4V10H0V12H4V16H6V12H10V16H12V12H16V10H12V6H16ZM10 10H6V6H10V10Z"
                    fill="#94A6B8"
                  />
                </svg>

                <SpecialLabelText>Customer reference</SpecialLabelText>
              </SpecialLabel>
            </SectionLine>
            <SectionLine>
              <FormikPremiumInput
                isDisabled={isReadOnly}
                label={'Customer reference'}
                name="order_data.complementary_info.customer_internal_reference"
              />
            </SectionLine>
          </Half>
          <Half>
            <SectionLine>
              <SpecialLabel>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <g clipPath="url(#clip0_881_214)">
                    <path
                      d="M16 8C16 6.41775 15.5308 4.87104 14.6518 3.55544C13.7727 2.23985 12.5233 1.21447 11.0615 0.608967C9.59966 0.00346601 7.99113 -0.154961 6.43928 0.153721C4.88743 0.462403 3.46196 1.22433 2.34314 2.34315C1.22432 3.46197 0.462398 4.88743 0.153716 6.43928C-0.154965 7.99113 0.00346046 9.59966 0.608962 11.0615C1.21446 12.5233 2.23984 13.7727 3.55544 14.6518C4.87103 15.5308 6.41775 16 8 16C10.121 15.9977 12.1545 15.1541 13.6543 13.6543C15.1541 12.1545 15.9977 10.121 16 8ZM1.33333 8C1.33333 6.68146 1.72432 5.39253 2.45687 4.2962C3.18941 3.19987 4.2306 2.34539 5.44878 1.84081C6.66695 1.33622 8.00739 1.2042 9.3006 1.46143C10.5938 1.71867 11.7817 2.35361 12.714 3.28596C13.6464 4.21831 14.2813 5.4062 14.5386 6.6994C14.7958 7.99261 14.6638 9.33305 14.1592 10.5512C13.6546 11.7694 12.8001 12.8106 11.7038 13.5431C10.6075 14.2757 9.31854 14.6667 8 14.6667C6.23248 14.6647 4.53792 13.9617 3.2881 12.7119C2.03827 11.4621 1.33527 9.76752 1.33333 8Z"
                      fill="#94A6B8"
                    />
                    <path
                      d="M13.3333 7.99999C13.3333 7.91158 13.2982 7.8268 13.2357 7.76429C13.1732 7.70177 13.0884 7.66666 13 7.66666L8.33333 7.66666L8.33333 2.99999C8.33333 2.91158 8.29822 2.8268 8.2357 2.76429C8.17319 2.70178 8.08841 2.66666 8 2.66666C6.94517 2.66666 5.91402 2.97945 5.03696 3.56548C4.1599 4.15152 3.47631 4.98447 3.07264 5.95901C2.66898 6.93355 2.56336 8.0059 2.76915 9.04047C2.97493 10.075 3.48288 11.0253 4.22877 11.7712C4.97465 12.5171 5.92495 13.0251 6.95952 13.2308C7.99408 13.4366 9.06644 13.331 10.041 12.9273C11.0155 12.5237 11.8485 11.8401 12.4345 10.963C13.0205 10.086 13.3333 9.05482 13.3333 7.99999Z"
                      fill="#94A6B8"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_881_214">
                      <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(16) rotate(90)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <SpecialLabelText>Deadline set by the customer</SpecialLabelText>
              </SpecialLabel>
            </SectionLine>
            <SectionLine>
              <Half>
                <FormikPremiumInput
                  isDisabled={isReadOnly}
                  label="Date"
                  name="order_data.complementary_info.customer_deadline_date"
                  type="date"
                />
              </Half>
              <Half>
                <FormikPremiumInput
                  isDisabled={isReadOnly}
                  label="Time"
                  name="order_data.complementary_info.customer_deadline_time"
                  type="time"
                  showErrors={showErrors}
                />
              </Half>
            </SectionLine>
          </Half>
        </SectionLine>
        {/* additional services */}
        <SectionLine>
          <CustomSpace />
        </SectionLine>
        <SectionLine>
          <Half>
            <SectionLine>
              <SpecialLabel>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_1156_3721)">
                    <path
                      d="M1.64705 9.69555H3.34116C3.80705 9.69555 4.18822 9.31437 4.18822 8.84849V7.15437C4.18822 6.68849 3.80705 6.30732 3.34116 6.30732H1.64705C1.18116 6.30732 0.799988 6.68849 0.799988 7.15437V8.84849C0.799988 9.31437 1.18116 9.69555 1.64705 9.69555ZM1.64705 13.9308H3.34116C3.80705 13.9308 4.18822 13.5497 4.18822 13.0838V11.3897C4.18822 10.9238 3.80705 10.5426 3.34116 10.5426H1.64705C1.18116 10.5426 0.799988 10.9238 0.799988 11.3897V13.0838C0.799988 13.5497 1.18116 13.9308 1.64705 13.9308ZM1.64705 5.46026H3.34116C3.80705 5.46026 4.18822 5.07908 4.18822 4.6132V2.91908C4.18822 2.4532 3.80705 2.07202 3.34116 2.07202H1.64705C1.18116 2.07202 0.799988 2.4532 0.799988 2.91908V4.6132C0.799988 5.07908 1.18116 5.46026 1.64705 5.46026ZM5.88234 9.69555H14.3529C14.8188 9.69555 15.2 9.31437 15.2 8.84849V7.15437C15.2 6.68849 14.8188 6.30732 14.3529 6.30732H5.88234C5.41646 6.30732 5.03528 6.68849 5.03528 7.15437V8.84849C5.03528 9.31437 5.41646 9.69555 5.88234 9.69555ZM5.88234 13.9308H14.3529C14.8188 13.9308 15.2 13.5497 15.2 13.0838V11.3897C15.2 10.9238 14.8188 10.5426 14.3529 10.5426H5.88234C5.41646 10.5426 5.03528 10.9238 5.03528 11.3897V13.0838C5.03528 13.5497 5.41646 13.9308 5.88234 13.9308ZM5.03528 2.91908V4.6132C5.03528 5.07908 5.41646 5.46026 5.88234 5.46026H14.3529C14.8188 5.46026 15.2 5.07908 15.2 4.6132V2.91908C15.2 2.4532 14.8188 2.07202 14.3529 2.07202H5.88234C5.41646 2.07202 5.03528 2.4532 5.03528 2.91908Z"
                      fill="#94A6B8"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1156_3721">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <SpecialLabelText>Additional services</SpecialLabelText>
              </SpecialLabel>
            </SectionLine>
            <SectionBody>
              <SectionLine>
                <CheckboxsContainer>
                  {ADDITIONAL_SERVICES.map((s) => (
                    <Checkbox
                      key={s.value}
                      name="order_data.complementary_info.additional_services"
                      value={s.value}
                      label={s.label}
                      isDisabled={isReadOnly}
                    />
                  ))}
                </CheckboxsContainer>
              </SectionLine>
              <SectionLine>
                <FormikPremiumInput
                  isDisabled={isReadOnly}
                  label="Other"
                  name="order_data.complementary_info.other_additional_services"
                />
              </SectionLine>
            </SectionBody>
          </Half>
        </SectionLine>
      </SectionBody>
    </SectionContainer>
  );
};
